export function registrarVisualizacion(id, servicio) {
  const logs = JSON.parse(localStorage.getItem("auditoria") || "[]");

  logs.push({
    id,
    servicio,
    fecha: new Date().toISOString(),
  });

  localStorage.setItem("auditoria", JSON.stringify(logs));
}
